import { render, staticRenderFns } from "./PageViewsTable.vue?vue&type=template&id=4d6c1aba"
import script from "./PageViewsTable.vue?vue&type=script&lang=js"
export * from "./PageViewsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports